
const svgHelper = {
  /**
   * @param icon the id of the icon contained within the sprite
   * @param sprite whether the icon is in the "primary" or "secondary" sprite
   * @returns {string} the full path to the sprite and icon including the cache hash
   */
  svg_path(icon, sprite = 'primary') {
    const file = sprite === 'primary' ? 'svg-library-primary.svg' : 'svg-library-secondary.svg';
    const hash = sprite === 'primary' ? SVG_HASH_PRIMARY : SVG_HASH_SECONDARY;

    return `/fa/shared/${file}?${hash}#${icon}`;
  }
};

export default svgHelper
